<template>
  <header class="ue-header">
    <div class="ue-header-container container">
      <div class="ue-header-left">
        <span class="logo">
          <img @click="goPage" :src="logoUrl" />
          <span class="version" @click="showVersion">{{ version.name }}</span>
        </span>
        <router-link class="ue-link" to="/index" active-class="ue-link-active"
          >首页</router-link
        >
        <router-link class="ue-link" to="/course" active-class="ue-link-active"
          >课堂</router-link
        >
        <router-link class="ue-link" to="/topic" active-class="ue-link-active"
          >专题</router-link
        >
        <router-link
          class="ue-link"
          to="/resource"
          active-class="ue-link-active"
          >竞品资源</router-link
        >
        <router-link class="ue-link" to="/insight" active-class="ue-link-active"
          >洞察手册</router-link
        >
        <!-- <router-link class="ue-link" to="/resource" active-class="ue-link-active">资源</router-link> -->
        <!-- <el-dropdown @command="resourceHandle" placement="bottom">
          <div class="ue-header-resource">资源</div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="resource">竞品资源</el-dropdown-item>
            <el-dropdown-item command="insight">洞察手册</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <div class="ue-search">
          <input v-model="searchMsg" @keyup.enter="toSearch" />
          <img :src="searchUrl" @click="toSearch" />
          <!-- <img :src="searchUrl"  @click="handleOpen()" /> -->
        </div>
      </div>
      <div class="ue-header-right" v-if="!user">
        <span class="ue-btn ue-btn-light" @click="login">登录</span>
      </div>
      <div class="ue-header-right" v-else>
        <el-dropdown @command="handleCommand">
          <span class="ue-header-user">
            <img class="ue-header-avatar" :src="user.avatar" />
            <i
              style="margin-left: 5px; color: #999999"
              class="el-icon-caret-bottom"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="usercenter" v-if="user.author === 2"
              >个人中心</el-dropdown-item
            >
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span
          class="ue-btn ue-btn-filling"
          v-if="user.author === 2"
          @click="handleOpen()"
          >写文章</span
        >
      </div>
    </div>
  </header>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import ShowVersion from "@/components/common/showversion";
import logo from "@/assets/img/logo.png";
import search from "@/assets/img/search.png";
import { loginUrl, logoutUrl } from "@/assets/js/const";
import Axios from "@/assets/js/ajax";
import WriteDialog from "@/components/common/writeDialog";
export default {
  name: "ue-header",
  data() {
    return {
      logoUrl: logo,
      searchUrl: search,
      searchMsg: "",
      change: "",
      dialogVisible: false,
      version: {},
    };
  },
  computed: {
    ...mapGetters("home", ["user"]),
  },
  watch: {
    $route(to, from) {
      this.searchMsg = to.query.search;
    },
  },
  methods: {
    ...mapMutations("home", ["setUser"]),
    ...mapActions("home", ["getVersion"]),
    toSearch() {
      let routeUrl = this.$router.resolve({
        path: "/search",
        query: {
          search: this.searchMsg,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    goPage() {
      this.$router.push({
        name: "home",
      });
    },
    handleCommand(command) {
      if (command === "logout") {
        this.logout();
      } else if (command === "usercenter") {
        this.$router.push({
          name: "usercenter",
          params: {
            id: this.user.uid,
          },
        });
      }
    },
    resourceHandle(command) {
      this.$router.push({
        name: command,
      });
    },
    async logout() {
      console.log("logout");
      let { data } = await Axios.get(logoutUrl);
      location.href = "/";
      this.setUser(null);
      gio("clearUserId");
    },
    handleOpen() {
      WriteDialog.open();
    },
    formatDate(date) {
      let dateObj = new Date(date);
      let year = dateObj.getFullYear();
      let month =
        dateObj.getMonth() > 9
          ? dateObj.getMonth() + 1
          : "0" + (dateObj.getMonth() + 1);
      let day = dateObj.getDate();
      return year + "." + month + "." + day;
    },
    async showVersion() {
      ShowVersion.open(
        this.version.desc,
        this.version.name,
        this.formatDate(this.version.updateDate)
      );
    },
  },
  async created() {
    this.version = await this.getVersion();
  },
};
</script>
<style lang="scss">
@import "../../assets/css/var.scss";

.ue-header {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  border-bottom: 1px solid rgba(243, 243, 243, 1);
  font-weight: bold;
  background: #ffffff;
  z-index: 100;

  > .ue-header-container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > .ue-header-left {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      > * {
        margin-right: 46px;
      }

      > .logo {
        > img {
          width: 127px;

          &:hover {
            cursor: pointer;
          }
        }

        > .version {
          color: #343434;
          font-weight: 400;
          font-size: 12px;

          &:hover {
            cursor: pointer;
            color: #56a4ff;
          }
        }
      }

      > .ue-link {
        font-size: 16px;
        color: #333333;
        text-decoration: none;

        &:hover {
          color: $red;
        }
      }

      > .ue-link-active {
        color: $red;
      }

      > .ue-search {
        position: relative;

        > input {
          width: 229px;
          height: 38px;
          background: rgba(248, 248, 248, 1);
          border-radius: 19px;
          border: none;
          padding-left: 20px;
          outline: none;
          font-size: 16px;
        }

        > img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 16px;
          width: 24px;
          height: 24px;
        }
      }
    }

    > .ue-header-right {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      > * {
        margin-left: 21px;
      }

      .ue-header-user {
        display: inline-flex;
        align-items: center;

        &:hover {
          cursor: pointer;
        }

        > .ue-header-avatar {
          width: 40px;
          height: 40px;
          border-radius: 20px;
        }
      }
    }
  }
  .ue-header-resource {
    font-size: 16px;
    color: #333333;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>